import { memo } from 'react';

import { ColorStopObject } from './types';
import { forcePercent } from './utils';

const GradientStop = (props: ColorStopObject) => {
  const { offset, opacity, color } = props;

  return <stop offset={forcePercent(offset)} stopColor={color} stopOpacity={opacity} />;
};

export default memo(GradientStop);
